import React from 'react';
import {Navigate} from 'react-router-dom';
import useAuth from "../hooks/use-auth";

interface GuardNotEmailVerifiedProps {
    children: React.ReactNode;
}

const GuardNotEmailVerified: React.FC<GuardNotEmailVerifiedProps> = ({children}) => {
    const {currentUser} = useAuth();

    if (currentUser && currentUser.hasEmailVerified) {
        return <Navigate to="/" replace/>;
    }

    return <>{children}</>;
};

export default GuardNotEmailVerified;
